export const getCommonPageTitle = (pageType: string) => {
    if (pageType === 'blog') {
        return 'Blog';
    }

    if (pageType === 'partners') {
        return 'Partners';
    }

    return '';
};

export const getCommonPageMetaContent = (pageType: string) => {
    if (pageType === 'blog') {
        return 'Read our blog to learn more about the best travel destinations, travel tips, and more.';
    }

    if (pageType === 'partners') {
        return 'Read our partners stories to learn more about the best travel destinations, travel tips, and more.';
    }

    return '';
};
